module.exports = __webpack_public_path__ + "img/LamdeiniLearning-150.d3df5668.jpg";